/**
 * auth-broadcast — บอกแท็บอื่นว่า session เปลี่ยนไปแล้ว (ADR 0228 D3)
 *
 * ล็อกใน `refresh-coordinator` กันไม่ให้พัง ตัวนี้กันไม่ให้ *ต้องแย่ง* ตั้งแต่แรก:
 * ทุกแท็บตั้งนาฬิกาจาก `exp` ของ token ที่ตัวเองเห็น ถ้าไม่บอกกัน ทุกแท็บจะตื่นพร้อมกัน
 * ทุก 14 นาทีไปตลอด
 *
 * และปิดช่องที่ logout แล้วแท็บอื่นยังคิดว่าตัวเองล็อกอินอยู่จนกว่าจะยิง request แล้วเจอ 401
 *
 * ไม่มี `BroadcastChannel` ก็ไม่พัง — แค่กลับไปเป็นพฤติกรรมเดิม (ล็อกยังทำงาน)
 */

const CHANNEL = "web-auth";

export type AuthBroadcast =
  /** refresh สำเร็จแล้ว — `exp` เป็นวินาที (หน่วยเดียวกับ JWT) */
  | { type: "refreshed"; exp: number }
  | { type: "logout" };

function channel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === "undefined") return null;
  try {
    return new BroadcastChannel(CHANNEL);
  } catch {
    return null;
  }
}

export function publishAuth(message: AuthBroadcast): void {
  const ch = channel();
  if (!ch) return;
  try {
    ch.postMessage(message);
  } finally {
    ch.close();
  }
}

/** คืนฟังก์ชันยกเลิก — ผู้เรียกต้องเรียกตอน unmount */
export function subscribeAuth(handler: (message: AuthBroadcast) => void): () => void {
  const ch = channel();
  if (!ch) return () => {};
  const onMessage = (e: MessageEvent<AuthBroadcast>) => {
    if (e.data && typeof e.data === "object" && "type" in e.data) handler(e.data);
  };
  ch.addEventListener("message", onMessage);
  return () => {
    ch.removeEventListener("message", onMessage);
    ch.close();
  };
}
